import { Variants } from '@amplitude/experiment-js-client';

export type Values<T> = T[keyof T];

export const AmplitudeFlagKeys = {
  dontServeCustomers: 'online-booking-unavailable',
  allowForOldOnlinebooking: 'allow-for-old-online-booking',
  obHideStepper: 'ob-hide-stepper',
  dynamicDurationInOlb: 'dynamic-duration-in-olb-and-ae',
  leadCaptureFileUpload: 'lead-capture-file-upload',
  leadCaptureAutoScrollToErrors: 'lead-capture-autoscroll-to-errors',
  serviceAreaV2: 'online-booking-service-area-v2-2',
} as const;

export type AmplitudeFlagType = Values<typeof AmplitudeFlagKeys>;

export const TruthyValuesForFlagKeys = {
  [AmplitudeFlagKeys.dontServeCustomers]: 'using-online-booking-unavailable',
  [AmplitudeFlagKeys.allowForOldOnlinebooking]: 'using-allow-for-old-online-booking',
  [AmplitudeFlagKeys.obHideStepper]: 'using-ob-hide-stepper',
  [AmplitudeFlagKeys.dynamicDurationInOlb]: 'using-dynamic-duration-in-olb-and-ae',
  [AmplitudeFlagKeys.leadCaptureFileUpload]: 'using-lead-capture-file-upload',
  [AmplitudeFlagKeys.leadCaptureAutoScrollToErrors]: 'using-lead-capture-autoscroll-to-errors',
  [AmplitudeFlagKeys.serviceAreaV2]: 'using-online-booking-service-area-v2-2',
} as const satisfies Record<AmplitudeFlagType, string>;

export const DefaultFlagValues: Variants = {} as const;
